import React, { useContext, useEffect, useState } from "react";
import AsyncSelect from "react-select/async";
import DatePicker from "react-datepicker";
import Select from "react-select";
import { useForm, Controller } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { GlobalContext } from "../../../../Contexts/GlobalContextProvider";
import iconcontentcalendar from "../../../../Images/Icons/iconcontentcalendar.png";
import { globalServices } from "../../../../Services/global.service";
import { AuthContext } from "../../../../Contexts/AuthContext";
import moment from "moment";

const TrafficFilters = ({ filters, setFilters, updateTable }) => {
  const { t: translator } = useTranslation();
  const { selectedLanguageId } = useContext(GlobalContext);
  const { tenantId, userId } = useContext(AuthContext);

  const { handleSubmit, errors, control, setValue } = useForm({
    mode: "submit",
    reValidateMode: "onSubmit",
  });

  const [stores, setStores] = useState([]);
  const [productGroups, setProductGroups] = useState([]);
  const [documentTypes, setDocumentTypes] = useState([]);

  useEffect(() => {
    if (Number(tenantId) > 0) {
      getStores(tenantId);
      getProductGroups(tenantId);
      getDocumentTypes(tenantId);
    }
  }, []);

  const getStores = tenantId => {
    globalServices.getStoresByTenantId(tenantId).then(res => {
      setStores(res.data);
    });
  };

  const getProductGroups = tenantId => {
    globalServices.getProductGroupsByTenantId(tenantId).then(res => {
      setProductGroups(res.data);
    });
  };

  const getDocumentTypes = tenant => {
    globalServices.getDocumentTypesByTenantId(tenantId).then(res => {
      setDocumentTypes(res.data);
    });
  };

  const tenantPromiseOptions = inputValue => {
    return globalServices
      .getTenantsRobno(
        Number(localStorage.getItem("tenantId")) > 0 ? userId : null,
        inputValue,
      )
      .then(res => {
        var result = res.data.map(e => ({
          id: e.id,
          label: e.name,
          value: e.name,
        }));
        return result;
      })
      .catch(err => err);
  };

  const handleToSearch = data => {
    const m = moment();

    // set date tp
    let date = moment(data?.dateTo);
    m.set(date.toObject());
    const dateTo = m.endOf("day").format("YYYY-MM-DDTHH:mm:ss");

    // Set date from
    date = moment(data?.dateFrom);
    m.set(date.toObject());
    const dateFrom = m.startOf("day").format("YYYY-MM-DDTHH:mm:ss");

    const searchFilters = {
      tenantId: data?.tenant?.id || Number(tenantId),
      storeTag: data?.store?.value || null,
      productGuid: null,
      productGroups: data?.productGroup
        ? data.productGroup.map(x => x.id).join()
        : null,
      documentTypeId: data?.documentType?.id || null,
      from: dateFrom,
      // to: data?.dateTo,
      to: dateTo,
    };
    setFilters(searchFilters);
    updateTable(new Date());
  };

  const dateFromMaxDate = () => {
    const lastDay = new Date(new Date(filters.from).getFullYear(), 11, 31);
    return lastDay > new Date() ? new Date() : lastDay;
  };

  return (
    <fieldset className="scheduler-border">
      <form onSubmit={handleSubmit(handleToSearch)}>
        <div className="row">
          {!(Number(tenantId) > 0) && (
            <div className="form-group col-lg-3 col-md-3 col-sm-4 col-xs-12">
              <label> {translator("InvIssReport-Filters-Tenants")}</label>
              <Controller
                as={<AsyncSelect isClearable />}
                control={control}
                name="tenant"
                defaultOptions={true}
                loadOptions={tenantPromiseOptions}
                placeholder={translator("Select-Tenant")}
                onChange={e => {
                  setValue("store", null);
                  setValue("productGroup", null);
                  setValue("documentType", null);
                  if (e[1].action == "clear") {
                    setFilters({ ...filters, tenantId: null });
                    setStores([]);
                    setProductGroups([]);
                    setDocumentTypes([]);
                    return null;
                  }
                  setFilters({ ...filters, tenantId: e[0].id });
                  getStores(e[0].id);
                  getProductGroups(e[0].id);
                  getDocumentTypes(e[0].id);
                  return e[0];
                }}
                rules={{
                  validate: function (value) {
                    if (!value) return false;
                    return value.value === 0 ? false : true;
                  },
                }}
              />
              {errors.tenant && errors.tenant.type === "validate" && (
                <p className="text-danger">
                  {translator("ValidationMsg-RequiredField")}
                </p>
              )}
            </div>
          )}
          <div className="form-group col-lg-3 col-md-4 col-xs-12">
            <label htmlFor="ddlStore">
              {translator("POS-New_EditPOS-Store")}
            </label>{" "}
            <Controller
              as={<Select isClearable />}
              disabled={!filters.tenantId}
              options={
                stores &&
                stores.map(p => ({
                  id: p.id,
                  label: p.name,
                  value: p.tag,
                }))
              }
              name="store"
              control={control}
              placeholder={translator("Select-Store")}
            />
          </div>
          <div className="form-group col-lg-3 col-md-4 col-xs-12">
            <label htmlFor="ddlStore">
              {translator("Filters-ProductGroups")}
            </label>
            <Controller
              as={<Select isMulti />}
              disabled={!filters.tenantId}
              options={
                productGroups &&
                productGroups.map(p => ({
                  id: p.id,
                  label: p.name,
                  value: p.id,
                }))
              }
              name="productGroup"
              control={control}
              placeholder={translator("Select-ProductGroup")}
            />
          </div>
          <div className="form-group col-lg-3 col-md-4 col-xs-12">
            <label htmlFor="ddlStore">
              {translator("Filters-DocumentType")}
            </label>{" "}
            <Controller
              as={<Select isClearable />}
              disabled={!filters.tenantId}
              options={
                documentTypes &&
                documentTypes.map(p => ({
                  id: p.id,
                  label: p.name,
                  value: p.id,
                }))
              }
              name="documentType"
              control={control}
              placeholder={translator("Select-DocumentType")}
            />
          </div>
        </div>
        <div className="row">
          <div className="form-group col-lg-3 col-md-3 col-sm-4 col-xs-12">
            <label>{translator("Filters-DateFrom")}</label>
            <div className="input-group">
              <div className="input-group-prepend">
                <span className="input-group-text">
                  <img src={iconcontentcalendar} alt="calendar" />
                </span>
              </div>
              <Controller
                as={DatePicker}
                control={control}
                className="form-control"
                autoComplete="off"
                name="dateFrom"
                valueName="selected"
                rules={{ required: true }}
                showYearDropdown={true}
                dateFormat="dd.MM.yyyy"
                locale={Number(selectedLanguageId) === 1 ? "hr" : "en"}
                onChange={function ([selected]) {
                  console.log(selected);
                  setFilters({
                    ...filters,
                    from: selected,
                    to: null,
                  });
                  setValue("dateTo", null);
                  return selected;
                }}
                maxDate={new Date()}
              />
            </div>
            {errors.dateFrom && errors.dateFrom.type === "required" && (
              <p className="text-danger">
                {translator("ValidationMsg-RequiredField")}
              </p>
            )}
          </div>
          <div className="form-group col-lg-3 col-md-3 col-sm-4 col-xs-12">
            <label>{translator("Filters-DateTo")}</label>
            <div className="input-group">
              <div className="input-group-prepend">
                <span className="input-group-text">
                  <img src={iconcontentcalendar} alt="calendar" />
                </span>
              </div>
              <Controller
                as={DatePicker}
                control={control}
                className="form-control"
                autoComplete="off"
                name="dateTo"
                valueName="selected"
                rules={{ required: true }}
                showYearDropdown={true}
                dateFormat="dd.MM.yyyy"
                locale={Number(selectedLanguageId) === 1 ? "hr" : "en"}
                onChange={function ([selected]) {
                  setFilters({ ...filters, to: selected });
                  return selected;
                }}
                disabled={!filters.from}
                minDate={new Date(filters.from)}
                maxDate={dateFromMaxDate()}
              />
            </div>
            {errors.dateTo && errors.dateTo.type === "required" && (
              <p className="text-danger">
                {translator("ValidationMsg-RequiredField")}
              </p>
            )}
          </div>
        </div>
        <div className="row">
          <label>{""}</label>
          <div className="form-group">
            <button
              className="btn btn-primary pull-left ml-3 mt-2"
              type="submit">
              <span className="icon icon-search"></span>{" "}
              {translator("InvIssReport-Btn-Search")}
            </button>
          </div>
        </div>
      </form>
    </fieldset>
  );
};

export default TrafficFilters;
